import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import vendorService from '../api/vendorService';

export const useAdminAllVendors = (params) => {
    return useQuery({
        queryKey: ['adminAllVendors', params],
        queryFn: () => vendorService.getAllVendors(params),
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000 // cache for 5 minutes
    });
};

export const useAdminVendorDetails = (vendorId) => {
    return useQuery({
        queryKey: ['adminVendorDetails', vendorId],
        queryFn: () => vendorService.adminGetVendor(vendorId),
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000 // cache for 5 minutes
    });
};

export const useUpdateBankDetails = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (bankDetails) => vendorService.updateVendorBankDetails(bankDetails),
        onSuccess: () => {
            queryClient.invalidateQueries(['currentVendor']);
        }
    });
};
